import React from 'react';
import './FileLink.sass';
import { constructDevSrc, formatBytes } from '../../utils/helpers';

import { ReactComponent as PdfIco } from './pdf-ico.svg';

interface Props {
	fileName: string;
	fileUrl: string;
	size: number;
	updateDate: string;
}

function FileLink(props: Props) {
	const { fileName, fileUrl } = props;
	return (
		<a
			href={constructDevSrc(fileUrl)}
			target="_blank"
			download
			className="uikit-file-link"
			rel="noreferrer"
		>
			<div className="uikit-file-link__ico">
				<PdfIco />
			</div>
			<div className="uikit-file-link__file">
				<span className="uikit-text-regular">{fileName}</span>
				<span className="uikit-label-tag-light">
					{formatBytes(props.size)} Last Updated {props.updateDate}
				</span>
			</div>
		</a>
	);
}

export default FileLink;
